'use strict';

import Vue from 'vue';
import './search';

Vue.component('pagination', require('../components/Pagination.vue').default);
Vue.component('blog', require('../components/articles/Blog.vue').default);
Vue.component('news', require('../components/articles/News.vue').default);
Vue.component('selections', require('../components/articles/Selections.vue').default);
Vue.component('video-list', require('../components/articles/Video.vue').default);

Math.easeInOutQuad = function (t, b, c, d) {
  t /= d/2;
  if (t < 1) return c/2*t*t + b;
  t--;
  return -c/2 * (t*(t-2) - 1) + b;
};

new Vue({
  el: '#articles-app',
  methods: {
    declOfNum(number, titles) {
      return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ? number % 10 : 5]];
    }
  }
});
